import { useDebounce } from 'hooks/useDebounce';
import { CardContainer } from 'layout/Card';
import CardContainerTitleSeeAll from 'layout/Card/CardContainer/CardContainerTitleSeeAll';
import OrganizationBuildingsWithTagsTable from 'pages/OrganizationViewPage/tables/OrganizationBuildingsAttention/OrganizationBuildingsWithTagsTable';
import { useQuerySearch } from 'pages/OrganizationViewPage/tables/OrganizationAnomaliesTable/hook/useQuerySearch';
import { type ChangeEvent, type FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const OrganizationBuildingsWithTagsComponent: FC = () => {
  const { t } = useTranslation();
  const { setQuerySearch } = useQuerySearch();
  const [search, setSearch] = useState('');
  const debouncedQuery = useDebounce(search, 500);

  const handleSearchInput = (event: ChangeEvent<HTMLInputElement>): void => {
    setSearch(event.target.value);
  };

  useEffect(() => {
    setQuerySearch(debouncedQuery);
  }, [debouncedQuery]);

  return (
    <div>
      <CardContainerTitleSeeAll
        title={t('organizationView.buildingsWithTags.title')}
        redirect="/app/assets/list#assets"
        enableSearchBar={true}
        searchBarOptions={{
          onChange: handleSearchInput,
          value: search,
          placeholder: t('organizationView.components.searchBar.placeholder'),
        }}
      />
      <CardContainer>
        <OrganizationBuildingsWithTagsTable />
      </CardContainer>
    </div>
  );
};
export default OrganizationBuildingsWithTagsComponent;
